import { Component, HostListener, OnInit, ViewContainerRef, ViewChild, AfterViewInit, OnDestroy, ComponentRef } from '@angular/core';
import { environment } from '../environments/environment';
import { getMessaging, getToken, isSupported, onMessage } from 'firebase/messaging';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Platform } from '@angular/cdk/platform';
import { SwPush, SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter, map } from 'rxjs/operators';
import { PushNotificationsService } from './utilities/services/push-notification.service';
import { HttpService } from './utilities/services/http.service';
import { MatDialog } from '@angular/material/dialog';
import { IdleTimeoutService } from './utilities/services/idle-timeout.service';
import { TokenService } from './utilities/services/token.service';
import { ConfirmationDialogComponent } from './idle-timeout-dialog/idle-timeout-dialog.component';
import { interval } from 'rxjs';
////
import { ChatComponent } from './chat/chat.component';
import { ConnectionsComponent } from './connections/connections.component';
import { ContactInfoComponent } from './contact-info/contact-info.component';
import { NewMessageComponent } from './new-message/new-message.component';
import { SearchUserComponent } from './search-user/search-user.component';
import { NotificationComponent } from './notification/notification.component';
import { ChatService } from './utilities/services/chat.service';
////
import { DebugLoggingService } from './sembra-components/utilities/services/debug-logging.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  private static instances: AppComponent[] = [];

  title = 'sembracare-chat-frontend';

  message: any = null;
  isOnline: boolean;
  modalVersion: boolean;
  modalPwaEvent: any;
  modalPwaPlatform: string | undefined;
  currentApplicationVersion = environment.appVersion;

  notificationsShown: boolean = false;
  notificationComponent?: ComponentRef<NotificationComponent>;
  showPopupBlockedBanner: boolean = false;

  ////////////////////
  chatPopupState: 'closed' | 'open' | 'minimized' = 'closed';
  private ignoreNextOutsideClick: boolean = false;
  private clickStartedInside: boolean = false;
  openChatList: string[] = [];
  unreadCountList: any[] = [];
  @ViewChild('dynamicall', { read: ViewContainerRef })
  private viewRef!: ViewContainerRef;
  isLoggedIn: boolean = false;
  intervalSubscription!: any;
  unreadCountSubscription!: any;
  tokenRenewalSubscription!: any;
  connectionsComponent!: any;
  pendingMessageFrom: string | null = null;
  //////////////////////////

  constructor(public chatService: ChatService, public translate: TranslateService,
    private router: Router, private platform: Platform, private swUpdate: SwUpdate,
    private swPush: SwPush, private httpService: HttpService,
    private activatedRoute: ActivatedRoute, private _notificationService: PushNotificationsService,
    private idleTimeoutService: IdleTimeoutService, private dialog: MatDialog,
    private debugLogging: DebugLoggingService, private tokenService: TokenService) {
    AppComponent.instances.push(this);
    this.isOnline = false;
    this.modalVersion = false;

    translate.addLangs(['en', 'fr']);
    translate.setDefaultLang('en');
    const browserLang = translate.getBrowserLang() || 'en';
    translate.use(browserLang.match(/en|fr/) ? browserLang : 'en');

    this.debugLogging.configure({
      enabled: environment.production, // logs will be spammed when recompiling in dev
      endpoint: 'https://logger.mysembra.com',
      autoSendOnError: true,
      getUserId: () => {
        let storedEmail = localStorage.getItem('userEmail');
        if (storedEmail != null) // its something like this in mysembra
          return storedEmail
        else
          return 'anonymous';
      },
      getMetadata: () => ({ // additional data to attach to each log
        appVersion: environment.appVersion || '?.?.?',
        appName: 'sembracare-chat-frontend',
        appEnvironment: environment.production ? 'production' : 'development'
      })
    });
    this.debugLogging.initialize();

    const urlParams = new URLSearchParams(window.location.search);
    const messageFrom = urlParams.get('messageFrom');
    if (messageFrom) {
      this.pendingMessageFrom = messageFrom;
    }
  }

  isStaging() {
    return environment.staging;
  }

  ngOnInit(): void {
    // this.idleTimeoutService.startWatching(300, 240);
    // this.idleTimeoutService.startWatching(1000, 940);
    this.idleTimeoutService.startWatching(43200, 43140);

    this.idleTimeoutService.getWarningObservable().subscribe(() => {
      if (this.router.url !== '/login') {
        // console.log("inside");
        this.showWarningDialog();
      }
    });

    this.idleTimeoutService.getTimeoutObservable().subscribe(() => {
      this.logout();
    });

    this.setupUserActivityListener();
    this.startTokenRenewalCheck();
    this.activatedRoute.queryParams.subscribe((params) => {
      // console.log(params);
      if (params['token']) {
        let refreshToken = params['token'];
        let Username = params['email'];

        // console.log(Username);
        // console.log(refreshToken);
        if (Username && refreshToken) {
          const data = {
            realm: 'Sembracare',
            Username: Username,
            Refreshtoken: refreshToken,
          };
          this.magicLogin(data);
        }
      } else {
        const token = localStorage.getItem('userRealm');

        let windowPath = window.location.toString();
        let onGuestPage = windowPath.length == 1 || windowPath[windowPath.length - 1] == '/' ||
          windowPath.indexOf('login') > -1 || windowPath.indexOf("forgot-password") > -1 || windowPath.indexOf("login") > -1
          || windowPath.indexOf("reset-password") > -1 || windowPath.indexOf("sembratime") > -1 //|| windowPath.indexOf("onboard") > -1
          || windowPath.indexOf("verify-code") > -1 || windowPath.indexOf("resend-code") > -1;

        if (token) {
          // Redirect to /home only if on root path
          if (onGuestPage) { // for if user has a bookmark to login page
            this.router.navigate(['/home']);
          }
        }
        else {
          if (!onGuestPage) { // for if user has a bookmark to login page
            this.logout();
          }

        }
      }
    });

    this._notificationService.requestPermission();
    this.checkNotificationPermission();
    this.checkPopupPermission();
    this.updateOnlineStatus();

    window.addEventListener('online', this.updateOnlineStatus.bind(this));
    window.addEventListener('offline', this.updateOnlineStatus.bind(this));

    if (this.swUpdate.isEnabled) {
      this.swUpdate.versionUpdates.pipe(
        filter(
          (evt: any): evt is VersionReadyEvent => evt.type === 'VERSION_READY'
        ),
      ).subscribe(() => {
        this.modalVersion = true;
      });
    }

    this.loadModalPwa();

    this.requestPermission();
    this.listen();

    let windowPath = window.location.pathname;
    if (windowPath.indexOf("forgot-password") > -1 || windowPath.indexOf("login") > -1
      || windowPath.indexOf("reset-password") > -1 || windowPath.indexOf("sembratime") > -1 //|| windowPath.indexOf("onboard") > -1
      || windowPath.indexOf("verify-code") > -1 || windowPath.indexOf("resend-code") > -1) {
      this.isLoggedIn = false
    } else
      this.isLoggedIn = true;
  }

  ngAfterViewInit(): void {
    this.unreadCountSubscription = interval(10000).subscribe(() => {
      this.getUnreadCount();
    });

    this.getUnreadCount();

    this.ShowNotificationComponent();

    if (this.pendingMessageFrom) {
      this.router.events.pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd)
      ).subscribe(() => {
        if (this.pendingMessageFrom && this.viewRef) {
          this.openChatWithUser(this.pendingMessageFrom);
          this.pendingMessageFrom = null;
        }
      });
    }
  }

  ngOnDestroy(): void {
    if (this.intervalSubscription) {
      this.intervalSubscription.unsubscribe();
    }
    if (this.unreadCountSubscription) {
      this.unreadCountSubscription.unsubscribe();
    }
    if (this.tokenRenewalSubscription) {
      this.tokenRenewalSubscription.unsubscribe();
    }
    const idx = AppComponent.instances.indexOf(this);
    if (idx >= 0) {
      AppComponent.instances.splice(idx, 1);
    }
  }

  static getAllInstances(): AppComponent[] {
    return [...AppComponent.instances]; // return a copy
  }

  showWarningDialog() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '400px',
      data: { warningTime: 60 },
    });

    const timeoutSub = this.idleTimeoutService.getTimeoutObservable().subscribe(() => {
      dialogRef.close();
      this.logout();
    });

    dialogRef.afterClosed().subscribe((result) => {
      timeoutSub.unsubscribe();
      if (result) {
        this.idleTimeoutService.resetTimer();
      } else {
        this.logout();
      }
    });
  }

  logout() {
    let currentUrl = this.router.url;
    if (currentUrl.indexOf('/threads/') > -1)
      currentUrl = '/threads';

    this.httpService.removePushToken({
      email: localStorage.getItem('userEmail'),
      pushToken: localStorage.getItem('pushToken'),
    }).subscribe();

    this.chatPopupState = 'closed';
    this.openChatList = [];
    this.connectionsComponent = null;
    this.viewRef.clear();
    this.notificationComponent = undefined;

    localStorage.clear();
    localStorage.setItem('redirectUrl', currentUrl);

    this.router.navigate(['/login']);
  }

  private isLoggingOut = false;

  setupUserActivityListener() {
    const guestPaths = ['forgot-password', 'login', 'reset-password', 'sembratime', 'verify-code', 'resend-code'];
    const resetEvents = ['mousemove', 'keydown', 'click', 'scroll'];
    resetEvents.forEach((event) => {
      window.addEventListener(event, () => {
        this.idleTimeoutService.resetTimer();
        const token = localStorage.getItem('userAccessToken');
        if (!token) {
          let windowPath = window.location.pathname;
          const onGuestPage = guestPaths.some(path => windowPath.indexOf(path) > -1);
          if (!onGuestPage && !this.isLoggingOut) {
            this.isLoggedIn = false;
            this.isLoggingOut = true;
            this.logout();
          }
        } else {
          this.isLoggedIn = true;
          this.isLoggingOut = false;
        }
      });
    });
  }

  checkNotificationPermission() {
    if (!('Notification' in window)) return;
    if (Notification.permission === 'default') {
      Notification.requestPermission().then((permission) => {
        if (permission === 'granted') {
          this._notificationService.permission = permission;
          this.requestPermission();
        }
      });
    }
  }

  checkPopupPermission() {
    const popup = window.open('about:blank', '_blank');
    if (!popup || popup.closed) {
      this.showPopupBlockedBanner = true;
    } else {
      popup.close();
      this.showPopupBlockedBanner = false;
    }
  }

  dismissPopupBanner() {
    this.showPopupBlockedBanner = false;
  }

  pushSubscription() {
    this.swPush
      .requestSubscription({ serverPublicKey: environment.firebase.vapidKey })
      .then((subscription: any) => {
        // send subscription to the server
        // localStorage.setItem('pushToken', subscription.getKey('token'));
      })
      .catch((error) => {});
  }

  async requestPermission() {
    const messaging = (await isSupported()) ? getMessaging() : null;
    if (messaging) {
      getToken(messaging, { vapidKey: environment.firebase.vapidKey })
        .then((currentToken) => {
          if (currentToken) {
            // console.log('Hurraaa!!! we got the token.....');
            // console.log(currentToken);
            localStorage.setItem('pushToken', currentToken);
            // Send the token to your server and update the UI if necessary
          } else {
            // Show permission request UI
            // ...
          }
        })
        .catch((err) => {
          // ...
        });
    }
  }

  async listen() {
    const messaging = (await isSupported()) ? getMessaging() : null;
    if (messaging) {
      onMessage(messaging, (payload) => {
        // console.log('Message received. ', payload);
        this.message = payload;

        let data: Array<any> = [];
        data.push({
          title: payload.notification?.title,
          alertContent: payload.notification?.body,
          data: {
            url: payload?.data?.['url'],
          },
        });

        this._notificationService.generateNotification(data);
      });
    }
  }

  private updateOnlineStatus(): void {
    this.isOnline = window.navigator.onLine;
  }

  public updateVersion(): void {
    this.modalVersion = false;
    window.location.reload();
  }

  public closeVersion(): void {
    this.modalVersion = false;
  }

  private loadModalPwa(): void {
    if (this.platform.ANDROID) {
      window.addEventListener('beforeinstallprompt', (event: any) => {
        event.preventDefault();
        this.modalPwaEvent = event;
        this.modalPwaPlatform = 'ANDROID';
      });
    }

    if (this.platform.IOS && this.platform.SAFARI) {
      const isInStandaloneMode =
        'standalone' in window.navigator &&
        (<any>window.navigator)['standalone'];
      if (!isInStandaloneMode) {
        this.modalPwaPlatform = 'IOS';
      }
    }
  }

  public addToHomeScreen(): void {
    this.modalPwaEvent.prompt();
    this.modalPwaPlatform = undefined;
  }

  public closePwa(): void {
    this.modalPwaPlatform = undefined;
  }

  magicLogin(data: any) {
    this.httpService.magicLogin(data).subscribe({
      complete: () => {
      },
      error: (error: any) => {
        this.router.navigate(['/login']);
      },
      next: (res: any) => {
        if (res) {
          if (res.accessToken) {
            localStorage.setItem('userEmail', data.Username.toLowerCase());
            localStorage.setItem('userId', data.Username.toLowerCase());
            localStorage.setItem('userAccessToken', res.idToken);
            localStorage.setItem('userRefreshToken', res.refreshToken);
            localStorage.setItem('userRealm', res.Realm);
            localStorage.setItem('Role', res.Role);
            localStorage.setItem('UserRole', res.UserRole);
            localStorage.setItem('userName', res.userName);
            localStorage.setItem('allAgencyCode', res.agencycode);
            localStorage.setItem('agencycode', res.agencycode?.split(';')[0]);
            if (res.chatGroups) {
              if (res.chatGroups.length > 0)
                localStorage.setItem('chatGroups', res.chatGroups);
            }
            localStorage.setItem('notificationPreferences', res.notificationPreferences);
            localStorage.setItem('_id', res._id);

            this.router.navigate(['/home']);
          }
        }
      },
    });
  }

  renewToken() {
    this.tokenService.renewToken().subscribe({
      error: (error) => {
        console.log('Renew token failed', error);
      },
      next: () => {
        console.log('Token renewed successfully');
      },
    });
  }

  startTokenRenewalCheck() {
    // Check every 60 seconds whether the token needs renewal
    this.tokenRenewalSubscription = interval(60000).subscribe(() => {
      const token = this.tokenService.getAccessToken();
      if (!token) return;

      // Renew if less than 5 minutes remain
      if (!this.tokenService.isTokenValid(300)) {
        this.renewToken();
      }
    });
  }

  //////////////////////////////////////////////////////

  openUnreadChat() {
    this.ignoreNextOutsideClick = true;
    if (this.chatPopupState === 'minimized') {
      this.chatPopupState = 'open';
      return;
    }
    if (this.chatPopupState === 'closed') {
      this.openChatList = [];
      this.addConnectionComponent();
    }
    else {
      this.closeChatEntirely();
    }
  }

  minimizeChat() {
    this.chatPopupState = 'minimized';
  }

  private closeChatEntirely() {
    this.viewRef.clear();
    this.connectionsComponent = null;
    this.openChatList = [];
    this.chatPopupState = 'closed';
    this.notificationComponent = undefined;
    this.ShowNotificationComponent();
  }

  @HostListener('document:mousedown', ['$event'])
  onDocumentMouseDown(event: MouseEvent) {
    const target = event.target as HTMLElement;
    const chatPopup = document.getElementById('myForm');
    const chatIcon = document.querySelector('.chat-icon-popup');
    const cdkOverlay = document.querySelector('.cdk-overlay-container');
    this.clickStartedInside = !!(
      chatPopup?.contains(target) ||
      chatIcon?.contains(target) ||
      cdkOverlay?.contains(target)
    );
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (this.ignoreNextOutsideClick) {
      this.ignoreNextOutsideClick = false;
      return;
    }
    if (this.chatPopupState !== 'open') return;
    if (window.innerWidth <= 440) return;
    if (this.clickStartedInside) return;

    this.minimizeChat();
  }

  getUnreadCount() {
    let socketConnected = this.chatService.socketConnected;
    const token = localStorage.getItem('userAccessToken');
    const userId: any = localStorage.getItem('userEmail') || null;
    if (token) {
      if (socketConnected) {
        this.httpService.getUnreadCounts(userId).subscribe({
          complete: () => {
            // console.log('done');
          },
          error: (error) => {
            if (error.status === 401) {
              this.tokenService.clearAndRedirect();
            }
            const msg = error.error ? error.error.message : error.message;
            // this.openSnackBar(msg, '');
          },
          next: (res) => {
            if (res.length > 0) {
              this.unreadCountList = res.filter((elements) => {
                return elements.email !== null;
              });
            } else {
              this.unreadCountList = [];
            }
          },
        });
      }
    }
  }

  getUnreadBadge() {
    if (this.unreadCountList.length > 0)
      return '-';
    else
      return '';
  }

  ShowNotificationComponent(fromHeader?) {
    if (this.viewRef) {
      if (!this.notificationComponent) {
        if (fromHeader)
          window.location.reload()
        else {
          this.notificationComponent = this.viewRef.createComponent(NotificationComponent, {
            index: 0,
          });
        }
      }
      else {
        this.notificationComponent.instance.toggleVisibility();
      }
    }
  }

  addChatComponent(email: string, name: string, group?: string, connectionId?: string, alertGroup?: boolean) {
    if (this.viewRef) {
      if (this.openChatList.includes(email)) return;
      this.openChatList.push(email);
      const componentRef = this.viewRef.createComponent(ChatComponent, {
        index: 0,
      });
      componentRef.instance.toChatUserId = email;
      componentRef.instance.toChatUserName = name;
      componentRef.instance.connectionId = connectionId;
      componentRef.instance.alertGroup = alertGroup;
      if (group)
        componentRef.instance.groupName = group;
      componentRef.instance.fromNewMessage = false;
      componentRef.instance.forwardMsg = null;
      componentRef.instance.forwardMessage.subscribe((res) => {
        const fwdIdx = this.openChatList.indexOf(email);
        if (fwdIdx > -1) this.openChatList.splice(fwdIdx, 1);
        componentRef.destroy();
        this.addNewMessageScreen(res);
      })
      componentRef.instance.gotoConversations.subscribe((res) => {
        if (res) {
          const navIdx = this.openChatList.indexOf(email);
          if (navIdx > -1) this.openChatList.splice(navIdx, 1);
          componentRef.destroy();
          this.addConnectionComponent();
        }
      });
    }
  }

  addConnectionComponent() {
    if (this.viewRef) {
      this.chatPopupState = 'open';
      this.connectionsComponent = this.viewRef.createComponent(ConnectionsComponent);
      this.connectionsComponent.instance.startChat.subscribe((res) => {
        if (res) {
          // console.log(res);
          // const indexElement = this.openChatList.findIndex(
          //   (el) => el === res.email
          // );
          // if (indexElement === -1) {
          this.gotoChat(res);
          this.chatPopupState = 'open';
          this.connectionsComponent.destroy();
          // }
        }
      });
      this.connectionsComponent.instance.openNewMessage.subscribe((res) => {
        if (res) {
          this.connectionsComponent.destroy();
          this.addNewMessageScreen();
        }
      });
      this.connectionsComponent.instance.openAddresBook.subscribe((res) => {
        if (res) {
          this.connectionsComponent.destroy();
          this.addUserComponent();
        }
      });
      this.connectionsComponent.instance.closeUser.subscribe((res) => {
        if (res) {
          this.minimizeChat();
        }
      });
    }
  }

  addContactInfoScreen(userData: any) {
    if (this.viewRef) {
      this.viewRef.clear();
      // viewRef.clear() destroyed the NotificationComponent -- recreate it
      this.notificationComponent = undefined;
      this.ShowNotificationComponent();
      this.chatPopupState = 'open';
      const componentRef = this.viewRef.createComponent(ContactInfoComponent);
      componentRef.instance.user = userData;
      componentRef.instance.startChat.subscribe((res) => {
        const indexElement = this.openChatList.findIndex(
          (el) => el === res.email
        );
        // if (indexElement === -1) {
        this.gotoChat(res);
        this.chatPopupState = 'open';
        componentRef.destroy();
        // }
      });
      componentRef.instance.gotoConversations.subscribe((res) => {
        if (res) {
          componentRef.destroy();
          this.addConnectionComponent();
        }
      });
      componentRef.instance.openAddresBook.subscribe((res) => {
        if (res) {
          componentRef.destroy();
          this.addUserComponent();
        }
      });
      componentRef.instance.openNewMessage.subscribe((res) => {
        if (res) {
          componentRef.destroy();
          this.addNewMessageScreen();
        }
      });
      componentRef.instance.closeUser.subscribe((res) => {
        if (res) {
          this.minimizeChat();
        }
      });
    }
  }

  addNewMessageScreen(forwardMsg?: any) {
    if (this.viewRef) {
      this.chatPopupState = 'open';
      const componentRef = this.viewRef.createComponent(NewMessageComponent);
      componentRef.instance.forwardMsg = forwardMsg;
      componentRef.instance.closeUser.subscribe((res) => {
        if (res) {
          this.minimizeChat();
        }
      });
      componentRef.instance.gotoConversations.subscribe((res) => {
        if (res) {
          componentRef.destroy();
          this.addConnectionComponent();
        }
      });
    }
  }

  addUserComponent() {
    if (this.viewRef) {
      this.chatPopupState = 'open';
      const componentRef = this.viewRef.createComponent(SearchUserComponent);
      componentRef.instance.startChat.subscribe((res) => {
        if (res) {
          this.addContactInfoScreen(res);
          componentRef.destroy();
        }
      });
      componentRef.instance.gotoConversations.subscribe((res) => {
        if (res) {
          componentRef.destroy();
          this.addConnectionComponent();
        }
      });
      componentRef.instance.openNewMessage.subscribe((res) => {
        if (res) {
          componentRef.destroy();
          this.addNewMessageScreen();
        }
      });
      componentRef.instance.closeUser.subscribe((res) => {
        if (res) {
          this.minimizeChat();
        }
      });
    }
  }

  openChatWithUser(email: string) {
    this.httpService.getUsers(email, 1).subscribe({
      next: (res: any) => {
        const users = res?.users || res;
        const user = Array.isArray(users)
          ? users.find((u: any) => u.user?.email?.toLowerCase() === email.toLowerCase() || u.email?.toLowerCase() === email.toLowerCase())
          : null;
        const name = user?.user?.userName || user?.userName || email;
        this.addChatComponent(email, name);
      },
      error: () => {
        this.addChatComponent(email, email);
      }
    });
  }

  gotoChat(user: any) {
    if (!this.checkYou(user.email)) {
      this.addChatComponent(user.email, user.name, user.group, user.connectionId, user.alertGroup);
    }
  }

  checkYou(email: string) {
    return localStorage.getItem('userEmail') === email;
  }
  ////////////////////////////////
}
